// status-progress-command-field.ts
//
// Progress panel (3.41): the `progress` key both `status --json` branches
// spread into the payload (autopilot-status-command.ts). `status` never fails
// because of the panel block: an unexpected read error drops the key and says
// so on stderr (stdout stays the one JSON line, H18) — never a silent gap.
import {
  type ReadStatusProgressInput,
  readStatusProgress,
} from "./status-progress-facts-reader.js";
import type { StatusProgress } from "./status-progress-types.js";

export async function readStatusProgressOrWarn(
  input: ReadStatusProgressInput,
): Promise<{ progress?: StatusProgress }> {
  try {
    return { progress: await readStatusProgress(input) };
  } catch (err) {
    process.stderr.write(`⚠ progress: ${err instanceof Error ? err.message : String(err)}\n`);
    return {};
  }
}
